"use client";
import { createContext } from "react";
export const AppsSDKUIContext = createContext(null);
//# sourceMappingURL=AppsSDKUIContext.js.map